import * as React from 'react'; // eslint-disable-line
import styled from 'styled-components';

import { COLOR, FONT_SIZE, LINE_HEIGHT, SPEED, TEXT_RELATIVE_MARGIN } from '../../packages/constants';

export enum Justify {
    Left = 'left',
    Right = 'right',
    Center = 'center',
}

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
    heading?: number;
    /**
     * Pass element type e.g. 'h1', 'p'
     * (Note: Font sizes for heading levels haven't been defined in constants yet)
     */
    as?: any;
    /**
     * Colour of text
     */
    color?: string;
    /**
     * Text justification
     */
    justify?: Justify;
    /**
     * Font-size with unit
     */
    fontSize?: string;
    /**
     * Line-height
     */
    lineHeight?: string;
    /**
     * Margin bottom with unit
     */
    marginBottom?: string;
    /**
     * Indent 28px (SPACING.XX_LARGE)
     */
    indent?: string;
}

// TODO: heading styles
const StyledText = styled.p`
    color: ${(props: TextProps) => (props.color ? props.color : COLOR.PRIMARY.BLACK)};
    text-align: ${(props: TextProps) =>
        props.justify === 'left'
            ? 'left'
            : props.justify === 'center'
            ? 'center'
            : props.justify === 'right'
            ? 'right'
            : 'left'};
    font-size: ${(props: TextProps) => props.fontSize || FONT_SIZE.MEDIUM};
    line-height: ${(props: TextProps) => props.lineHeight || LINE_HEIGHT.LARGE};
    margin-bottom: ${(props: TextProps) => props.marginBottom || TEXT_RELATIVE_MARGIN.MEDIUM};
    padding: 0 0 0 ${(props: TextProps) => (props.indent ? props.indent : '0')};
`;

export const TextLink = styled.a`
    transition: border-bottom-color ${SPEED.TRANSITION};
    color: ${COLOR.BRAND.REPORTING};
    text-decoration: none;
    padding-bottom: 1px;
    border-bottom: 1px solid transparent;

    &:hover {
        border-bottom: 1px solid ${COLOR.BRAND.REPORTING};
    }
`;

export const Text = ({ children, indent, heading, fontSize, ...props }: TextProps) => (
    <StyledText indent={indent} as={heading} fontSize={fontSize} {...props}>
        {children}
    </StyledText>
);
